/**
 * Schedules a task to run when the browser is idle, so it does not block the
 * critical rendering path. Falls back to `setTimeout` in browsers without
 * `requestIdleCallback` support (Safari).
 *
 * The timeout ensures the task also runs within a bounded delay on busy pages
 * where the browser never reports idle time.
 *
 * @returns a cancel function to abort the scheduled task (e.g. on unmount)
 */
export const runWhenIdle = (task: () => void, { timeout = 2000 }: IdleRequestOptions = {}) => {
  if (typeof requestIdleCallback === 'function') {
    const handle = requestIdleCallback(task, { timeout });

    return () => cancelIdleCallback(handle);
  }

  const handle = setTimeout(task, 1);

  return () => clearTimeout(handle);
};
